<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>物业管理</el-breadcrumb-item>
      <el-breadcrumb-item>物业费设置</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-input size="small" @keyup.enter.native="search" v-model="formInline.priceName" placeholder="物业费名称"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
        <el-select v-model="formInline.depId" placeholder="请选择部门" size="small">
          <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="pw:add" @click="handleEdit()"
          label="添加" />

      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
      <el-table-column align="center" type="index" width="60" label="序号">
      </el-table-column>
      <el-table-column prop="priceName" label="物业费名称">
      </el-table-column>

      <el-table-column label="物业费类型">
        <template slot-scope="scope">
          <span v-if="scope.row.tariffType  == 1">单一物业费</span>
          <span v-if="scope.row.tariffType  == 2">月阶梯物业费</span>
          <span v-if="scope.row.tariffType  == 3">费率物业费</span>
          <span v-if="scope.row.tariffType  == 4">多费率阶梯物业费</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="fixedTelephoneNumber" label="组合描述">
			</el-table-column>
 -->
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
          <prems-button size="mini" perms="pw:detail" @click="handleEdit(scope.$index, scope.row)" label="编辑" />
          <!-- <el-button size="mini" @click="handleSet(scope.$index, scope.row)">设置</el-button> -->
          <prems-button size="mini" type="warning" perms="pw:set" @click="handleSet(scope.row)" label="设置" />
          <!-- <el-button size="mini" type="danger"  @click="deleteInfo(scope.$index, scope.row)">删除</el-button> -->
          <prems-button size="mini" type="danger" perms="pw:delete" @click="deleteInfo(scope.$index, scope.row)"
            label="删除" />
        </template>
      </el-table-column>
    </el-table>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" @click="closeDialog"  :close-on-click-modal="false">
      <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm" style="padding: 0 30px;">


        <el-form-item v-if="user.username == 'admin'" label="选择部门">
          <el-select v-model="editForm.depId" placeholder="请选择部门" size="small">
            <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物业费名称" prop="priceName">
          <el-input size="small" v-model="editForm.priceName" auto-complete="off" placeholder="请输入物业费名称"></el-input>
        </el-form-item>
        <el-form-item label="物业费类型">
          <el-select size="small" disabled v-model="editForm.tariffType" filterable placeholder="选择物业费类型" style="width: 100%;"
            @change="onTypeChange">
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.lable" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物业费" prop="price" v-if="editForm.tariffType == 1">
          <el-input size="small" v-model="editForm.price" type="number" auto-complete="off" placeholder="0.00" style="width:200px;"></el-input>
          元/平
        </el-form-item>
        <div v-if="editForm.tariffType == 2">
          <el-row>
            <el-col :span="12">
              <el-form-item label="第一阶梯起始电量">
                <el-input size="small" v-model="editForm.firstStart" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                吨
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第一阶梯物业费">
                <el-input size="small" v-model="editForm.firstPrice" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="第二阶梯起始电量">
                <el-input size="small" v-model="editForm.secondStart" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                吨
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第二阶梯物业费">
                <el-input size="small" v-model="editForm.secondPrice" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="第三阶梯起始电量">
                <el-input size="small" v-model="editForm.thirdStart" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                吨
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第三阶梯物业费">
                <el-input size="small" v-model="editForm.thirdPrice" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="第四阶梯起始电量">
                <el-input size="small" v-model="editForm.fourthStart" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                吨
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第四阶梯物业费">
                <el-input size="small" v-model="editForm.fourthPrice" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="第五阶梯起始水量">
                <el-input size="small" v-model="editForm.fifthStart" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                吨
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第五阶梯物业费">
                <el-input size="small" v-model="editForm.fifthPrice" auto-complete="off" placeholder="0.00" style="width: 80%;"></el-input>
                元
              </el-form-item>
            </el-col>
          </el-row>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loadingSave" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定房间" :visible.sync="setFormVisible" width="45%" @click='closeDialog("set")' :close-on-click-modal="false">

      <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="getMeterForNoBind">添加</el-button>
      <el-button type="danger" size="small" style="margin-bottom: 10px;" @click="delMeter" :disabled="!tempDelMeterList.length">删除</el-button>
      <div style="line-height: 30px;">当前绑定的房间</div>
      <el-table size="small" :data="selectList" height="500px" border @selection-change="getDelMeterIds">
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="id" prop="id" width="100"></el-table-column>
        <el-table-column label="房间名称" prop="roomName"></el-table-column>
        <!-- <el-table-column label="用户姓名" prop="meterPoint"></el-table-column> -->

      </el-table>
      <div style="line-height: 40px;">共计:{{selectList.length}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加计量点界面 -->
    <el-dialog title="房间列表" :visible.sync="addFormVisible" width="36%" @click='addFormVisible = false' :close-on-click-modal="false">
      <el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input>
      <el-table size="small" :data="tables" height="500px" @selection-change="getAddMeterIds" ref='bindTable' v-loading="loadMeter">
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="id" prop="id" width="100"></el-table-column>
        <el-table-column label="房间名称" prop="roomName"></el-table-column>
        <!-- <el-table-column label="用户姓名" prop="meterPoint" width="200"></el-table-column> -->

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='addFormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="addMeters()">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import PremsButton from "@/views/permission/PreButtom";
  import {
    mapState
  } from 'vuex'
  import {
    addPriceConfig,
    notRoomName,
    deletePropertyPriceConfig,
    updatePropertyPriceConfig,
    findAllMeterInfoList,
    priceBindMeterinfo,
    checkPriceBindRoom,
    sendMeterInfoMsg,
    getPropertyPriceConfigList,
    addPropertyPriceConfig,
    priceBindRoom
  } from '../../api/payMG.js'
  import {
    getDepartmentTerminalInfoLis,
    findMeterInfoList
  } from '../../api/energyMG'
  export default {
    data() {
      var checkPrice = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('物业费不能为空'));
        }
        setTimeout(() => {
          if (value <= 0) {
            callback(new Error('物业费不能小于或者等于0'));
          } else {
            callback();
          }
        }, 1000);
      };
      return {
        selectDatas: [],
        selectList: [],
        deptList: [],
        user: {},
        formInline: {
          priceName: '',
          powerType: 64,
          depId: "",
        },
        loadingSave: false,
        editForm: {
          priceName: "",
          tariffType: 1, // 1单一物业费  2月阶梯物业费  3费率物业费 4 多费率阶梯物业费
          price: 0,
          firstStart: 0,
          firstPrice: 0,

          secondStart: 0,
          secondPrice: 0,

          thirdStart: 0,
          thirdPrice: 0,

          fourthStart: 0,
          fourthPrice: 0,

          fifthStart: 0,
          fifthPrice: 0,

          depId: ''
        },
        curPriceConfigId: "",
        ladderArr: [{
            firstStart: 0,
            firstPrice: 0
          },
          {
            secondStart: 0,
            secondPrice: 0
          },
          {
            thirdStart: 0,
            thirdPrice: 0
          },
          {
            fourthStart: 0,
            fifthPrice: 0
          },
          {
            fifthStart: 0,
            fifthPrice: 0
          },
        ],
        title: '添加',
        dataList: [],
        depId: "",
        loading: false,
        setLoading: false,
        loadMeter: false,
        editFormVisible: false,
        setFormVisible: false,
        addFormVisible: false,
        searchDatas: "",
        direction: "rtl",
        meterPointName: "",
        MeterInfoList: [],
        tempDelMeterList: [],
        tempAddMeterList: [],
        curPriceId: "",
        choiseNum: 0,
        energyType: "",
        typeOptions: [{
            id: 1,
            lable: "单一物业费"
          },
          {
            id: 2,
            lable: "月阶梯物业费"
          },
          {
            id: 3,
            lable: "费率物业费"
          },
          {
            id: 4,
            lable: "多费率阶梯物业费"
          },
        ],
        // rules表单验证
        rules: {

          priceName: [{
            required: true,
            message: '请输入物业费名称',
            trigger: 'blur'
          }],
          price: [{
            validator: checkPrice,
            trigger: 'blur'
          }]

        },
      }
    },


    created() {


      this.user = JSON.parse(sessionStorage.getItem('userdata'))


      //非管理员登录
      if (this.user.username != 'admin') {
        this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
        this.editForm.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId

        this.getdata();
      } else {
        //管理员登录
        this.getJzData().then(res => {
          this.formInline.depId = res.id
          this.getdata();
        });
      }




    },

    computed: {
      tables() {
        let search = this.searchDatas
        if (search) {
          return this.MeterInfoList.filter(data => {
            return Object.keys(data).some(key => {
              return String(data[key]).toLowerCase().indexOf(search) > -1
            })
          })
        }
        return this.MeterInfoList
      },
      ...mapState({
        energyConfig: 'energyConfig'
      })
    },
    methods: {


      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.deptList = res.data.menuDepList
              res.data.terIds.forEach(item => {
                arr.push({
                  id: item
                })
              })
              resolve(this.deptList[0])

            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },

      getDelMeterIds(e) {
        this.tempDelMeterList = e.map(item => item.id)
      },
      delMeter(e) {
        let arr = []
        this.selectList.forEach(item => {
          console.log(item.id)
          if (!(this.tempDelMeterList.indexOf(item.id) > -1)) {
            arr.push(item)
          }
        })
        this.selectList = arr
      },
      getAddMeterIds(e) {
        this.tempAddMeterList = e
      },
      addMeters() {
        let arr = this.selectList.concat(this.tempAddMeterList)
        this.selectList = Array.from(new Set(arr))
        this.addFormVisible = false
        this.tempAddMeterList = []
        this.$refs.bindTable.clearSelection();
      },
      searchMeter(e) {
        console.log(e)
      },
      subBindMeter() {
        let currMeterIds = this.selectList.map(item => item.id).join('-')
        let param = {
          priceId: this.curPriceId,
          roomIds: currMeterIds
        }


        //检查计量点是否已经绑定了其他价格
        let cparam = {
          priceId: this.curPriceId,
          roomIds: currMeterIds,
          powerType: 64
        }
        checkPriceBindRoom(cparam).then(res => {
          if (res.status == 1) {
            this.bindMeter(param)
          } else {
            let nmsg = res.msg.replace(/,/g, "<br/>")

            this.$confirm(nmsg, '信息', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(() => {
              this.bindMeter(param)
            })
          }
        })
      },
      bindMeter(param) {
        this.setLoading = true
        priceBindRoom(param)
          .then(res => {
            this.setLoading = false
            this.setFormVisible = false
            if (res.status == 1) {
              this.$message({
                type: 'success',
                message: '操作成功！'
              })
              this.getdata()
              // this.$store.dispatch('getSendMsg')
              //this.meterPointName = ""

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.setFormVisible = false
            this.setLoading = false
            this.$message.error('操作失败，请稍后再试！')
          })
      },
      getMeterForNoBind() {
        this.addFormVisible = true
        this.getMeterInfoList()
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata()
      },
      //显示编辑界面
      handleEdit: function(index, row) {


        console.log(this.editFormVisible)
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          this.editForm.id = row.id
          this.editForm.priceName = row.priceName
          this.editForm.tariffType = parseInt(row.tariffType)
          this.editForm.price = row.price || 0
          this.editForm.firstStart = row.firstStart || 0
          this.editForm.firstPrice = row.firstPrice || 0
          this.editForm.secondStart = row.secondStart || 0
          this.editForm.secondPrice = row.secondPrice || 0
          this.editForm.thirdStart = row.thirdStart || 0
          this.editForm.thirdPrice = row.thirdPrice || 0
          this.editForm.fourthStart = row.fourthStart || 0
          this.editForm.fourthPrice = row.fourthPrice || 0
          this.editForm.fifthStart = row.fifthStart || 0
          this.editForm.fifthPrice = row.fifthPrice || 0
          this.editForm.depId = row.departmentId
        } else {
          this.title = '添加'
          this.editForm.id = ""
          this.editForm.priceName = ""
          this.editForm.tariffType = 1
          this.editForm.price = 0
          this.editForm.firstStart = 0
          this.editForm.firstPrice = 0
          this.editForm.secondStart = 0
          this.editForm.secondPrice = 0
          this.editForm.thirdStart = 0
          this.editForm.thirdPrice = 0
          this.editForm.fourthStart = 0
          this.editForm.fourthPrice = 0
          this.editForm.fifthStart = 0
          this.editForm.fifthPrice = 0
          this.editForm.depId = this.formInline.depId
        }
      },

      //设置弹窗
      handleSet(row) {
        this.setFormVisible = true
        this.curPriceId = row.id
        this.selectDatas = []

        this.selectDatas = row.roomList.map(item => item.id)
        this.selectList = row.roomList


      },

      getMeterInfoList() {


        this.loadMeter = true
        let param = {
          depId: this.formInline.depId,
          // priceId: this.curPriceId,
          powerType:64
        }
        notRoomName(param).then(res => {
            this.loadMeter = false
            if (res.status == 1) {

              this.MeterInfoList = res.data.list

              //this.setChoisMeter(row)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loadMeter = false
            this.$message.error('获取数据失败，请稍后再试！')
          })

      },
      setChoisMeter(row) {
        let tempArr = []
        this.$nextTick(() => {
          this.$refs.bindTable.clearSelection(); //清除上一次除勾选项

          row.meterInfoVoList.forEach(item => {
            this.MeterInfoList.forEach((sitem, idx) => {
              if (item.id == sitem.id) {
                this.$refs.bindTable.toggleRowSelection(this.MeterInfoList[idx], true)
              }
            })
          })

        })
      },




      // 编辑、添加提交方法
      submitForm(editData) {
        this.loadingSave = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            if (this.title == '添加') {
              this.add();
            } else {
              this.update();
            }

          } else {
            this.loadingSave = false
            return false
          }
        })
      },



      getdata() {
        this.loading = true
        getPropertyPriceConfigList(this.formInline).then(res => {
            this.loading = false
            if (res.status == 1) {
              this.dataList = res.data
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.currentPage
              // this.pageparm.pageSize = this.formInline.pageSize
              // this.pageparm.total = res.data.totalCount

            } else {
              this.loading = false
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('获取数据失败，请稍后再试！')
          })
      },
      add() {
        let param = {
          ...this.editForm,
          powerType: 64
        }

        console.log(this.editForm)

        addPropertyPriceConfig(param)
          .then(res => {

            this.editFormVisible = false
            this.loadingSave = false
            if (res.status == 1) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
            } else {
              this.loadingSave = false
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loadingSave = false
            this.$message.error('添加失败，请稍后再试！')
          })
      },
      update() {
        let param = {
          ...this.editForm,
          powerType: 64
        }

        updatePropertyPriceConfig(param)
          .then(res => {

            this.editFormVisible = false
            this.loadingSave = false
            if (res.status == 1) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '操作成功！'
              })
            } else {
              this.loadingSave = false
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loadingSave = false
            this.$message.error('操作失败，请稍后再试！')
          })
      },
      // 删除
      deleteInfo(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            // 删除
            deletePropertyPriceConfig({
                id: row.id
              })
              .then(res => {
                if (res.status == 1) {
                  this.$message({
                    type: 'success',
                    message: '已删除!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },

      onTypeChange(e) {
        if (this.editForm.tariffType == 1) {

          this.editForm.firstStart = 0
          this.editForm.firstPrice = 0

          this.editForm.secondStart = 0
          this.editForm.secondPrice = 0

          this.editForm.thirdStart = 0
          this.editForm.thirdPrice = 0

          this.editForm.fourthStart = 0
          this.editForm.fourthPrice = 0

          this.fifthStart = ''
          this.fifthPrice = ''
        } else if (this.editForm.tariffType == 2) {
          this.editForm.price = 0
        }
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
        this.setFormVisible = false
      }
    },
    components: {

      PremsButton
    },
  }
</script>

<style scoped>
  .el-avatar,
  .el-drawer {
    overflow-y: auto !important;
  }

  .electriRule.dialog-footer {
    position: absolute;
    padding: 30px;
    text-align: right;
    bottom: 30px;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/property/SetProperty.vue